import {
    createNavigationProvider,
    type CommandSearchProvider,
    type NavigationSearchItem,
} from '../../components/panel-command-search';
import {queryPanelEntries} from '../registry';
import {resolvePanelEntryTarget, toPanelEntryContext} from '../access';
import {COMMAND_SEARCH_PROVIDER_CONFIG} from '../provider-config';
import type {PanelEntry} from '../types';

const toNavigationItem = (entry: PanelEntry): NavigationSearchItem => ({
    id: entry.id,
    title: entry.title,
    subtitle: entry.subtitle,
    keywords: entry.keywords,
    badge: entry.commandSearch?.badge,
    badgeColor: entry.commandSearch?.badgeColor,
    icon: entry.icon,
    to: entry.to,
    routeTemplate: entry.routeTemplate,
    scopeType: entry.scopeType,
    resolveTo: entry.resolveTo
        ? (ctx) => entry.resolveTo!(toPanelEntryContext(ctx))
        : undefined,
    accessKey: entry.accessKey,
    canAccess: entry.canAccess
        ? (ctx) => entry.canAccess!(toPanelEntryContext(ctx))
        : undefined,
    hide: typeof entry.hide === 'function'
        ? (ctx) => (entry.hide as (c: ReturnType<typeof toPanelEntryContext>) => boolean)(toPanelEntryContext(ctx))
        : entry.hide,
});

const createNavigationProviderFromRegistry = (providerId: string): CommandSearchProvider => {
    const config = COMMAND_SEARCH_PROVIDER_CONFIG[providerId];

    return createNavigationProvider({
        id: providerId,
        category: config?.category ?? 'pages',
        supersedes: config?.supersedes,
        enabled: config?.enabled
            ? (ctx) => config.enabled!(toPanelEntryContext(ctx))
            : undefined,
        items: (ctx) => queryPanelEntries({
            surface: 'command-search',
            providerId,
            ctx: toPanelEntryContext(ctx),
        }).map(toNavigationItem),
    });
};

/** Pre-built navigation providers for bootstrap registration. */
export const navigationProvidersFromRegistry: CommandSearchProvider[] = [
    createNavigationProviderFromRegistry('navigation-general'),
    createNavigationProviderFromRegistry('navigation-customer'),
    createNavigationProviderFromRegistry('navigation-vendor'),
];

export {resolvePanelEntryTarget};
